import { FC, useState, useEffect } from "react"
import { RouteComponentProps } from '@reach/router';
import { RootState } from 'reducers';
import { connect } from 'react-redux';
import EditPage, { EditStateAndDispatchProps } from "layouts/page-wraper/edit-page-modal";
import { createEntity, getEntity, reset, updateEntity, getBrandAll, queryBladeSystemSelect, fetchStoreList, searchCustomerList, fetchLevelList } from "./unit.reducer";
import { ProFormText, ProFormSelect, ProFormTextArea } from "@ant-design/pro-form";
import { Unit, ProvinceCode } from "model/dealer/unit.model";
import { Col, Form, Row, Select, Input, Button, Image } from 'antd';
import { Storage } from 'utils/storage-util';
import { internationalList } from "components/IntelFormText";
import CustomerSelectForm from './customer-select-form'
import { useEnumValue } from "common/enum/use-enum-value";

export interface UnitEditProps extends EditStateAndDispatchProps<Unit>, StateProps, DispatchProps, RouteComponentProps {
}
const { Option } = Select;
const UnitEdit: FC<UnitEditProps> = props => {
  const {
    ...editProps
  } = props;
  const [form] = Form.useForm();
  const [entityCopy, setEntityCopy] = useState<Unit>({});
  const { entity } = props;
  const [provinceSelectData, setProvinceSelectData] = useState<ProvinceCode[]>([]);
  const [citySelectData, setCitySelectData] = useState<ProvinceCode[]>([]);
  const [districtSelectData, setDistrictSelectData] = useState<ProvinceCode[]>([]);
  const [brandData, setBrandData] = useState<any>([]);
  // const [inviterData, setInviterData] = useState<any>([]);
  const [visible, setVisible] = useState<any>(false);
  const [selectRow, setSelectRow] = useState<any>({});
  const { convertEnumToOptionType } = useEnumValue();

  const handleProvinceChange = async (value: any, option: any) => {
    form.setFieldsValue({ addressApplication: { city: '', district: '', provinceName: '123' } });
    setCitySelectData(await getBladeSystemSelect(value));
    setDistrictSelectData([]);
  };


  const handleCityChange = async (value: any, option: any) => {
    form.setFieldsValue({ addressApplication: { district: '', cityName: option['children'] } });
    setDistrictSelectData(await getBladeSystemSelect(value));
  };

  useEffect(() => {
    console.log(entity)
    if (entity.id) {
      const entityCopy = JSON.parse(JSON.stringify(entity));
      entityCopy.avatar = entity.avatar;
      setEntityCopy(entityCopy);
      setDataFun('edite');
    } else {
      setDataFun('add');
      setEntityCopy({});
    }
    getSearchCustomerList({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entity]);

  // 获取所有品牌
  const getBrandList = async () => {
    const res = await getBrandAll();
    if (res) return res;
  }

  // 获取邀请人列表
  const getSearchCustomerList = async (params: any) => {
    searchCustomerList(params).then((res) => {
      // setInviterData(res)
    });

  }

  const setDataFun = async (type: string) => {
    setBrandData(await getBrandList())
    const xTenant = Storage.session.get("x-tenant");
    //const xTenant = 'ml';
    const regionObj: any = {
      merrige: ['00', '11', '1101'],
      ttw: ['01', '0101', '010101'],//台湾
      ml: ['N3', 'N301', 'N30101'],//马来西亚
      tsg: ['02', '0201', '020101'],//新加坡
    };
    const regionKey: 'merrige' | 'ttw' | 'ml' | 'tsg' = regionObj[xTenant] ? xTenant : 'merrige';
    if (type === 'edite') {
      setProvinceSelectData(await getBladeSystemSelect(regionObj[regionKey][0]));
      setCitySelectData(await getBladeSystemSelect(entity.addressApplication?.province));
      setDistrictSelectData(await getBladeSystemSelect(entity.addressApplication?.city));
    } else {
      setProvinceSelectData(await getBladeSystemSelect(regionObj[regionKey][0]));
      setCitySelectData(await getBladeSystemSelect(regionObj[regionKey][1]));
      setDistrictSelectData(await getBladeSystemSelect(regionObj[regionKey][2]));
    }
  };

  //联系地址
  const getBladeSystemSelect = async (code: string | number) => {
    const res = await queryBladeSystemSelect(code);
    if (res) return res;
  }

  const UpdateEntity = (data?: Unit) => {
    return new Promise<Unit>((resolve, reject) => {
      if (data) {
        const provinceName: any = provinceSelectData.filter(e => e.code === data?.addressApplication.province || '');
        const cityName: any = citySelectData.filter(e => e.code === data?.addressApplication.city || '');
        const districtName: any = districtSelectData.filter(e => e.code === data?.addressApplication.district || '');

        data && (data.addressApplication.provinceName = provinceName[0]?.provinceName);
        data && (data.addressApplication.cityName = cityName[0]?.cityName || '');
        data && (data.addressApplication.districtName = districtName[0]?.districtName || '');

        // 品牌组合
        if (data.brandIds) {
          let brandArr: any = []
          data.brandIds.forEach((item: any) => {
            brandData.forEach((item1: any) => {
              if (item === item1.id) {
                brandArr.push({
                  brandId: item,
                  brandName: item1.brandName
                })
              }
            });
          });
          data.brandDetails = brandArr
        }
        resolve(data)
      }
    })
  }

  return (
    <>
      <EditPage
        title="申请"
        beforeUpdateEntity={UpdateEntity}
        form={form}
        {...editProps}
        entity={entityCopy}
      >
        <Row>
          <Col span={5}>
            <ProFormText
              rules={[{ required: true }]}
              style={{ width: '80%' }}
              disabled
              name="name"
              label="申请人姓名"
              placeholder="请选择"
            />
            <ProFormText
              rules={[{ required: true }]}
              style={{ width: '80%' }}
              hidden
              name="userId"
            />
            <ProFormText
              rules={[{ required: true }]}
              style={{ width: '80%' }}
              hidden
              name="customerId"
            />
          </Col>
          <Col span={2} className="alignCenter">
            <Button type="primary" onClick={() => {
              setVisible(true)
            }}>选择</Button>

          </Col>
          <Col span={1} />
          <Col span={7}>
            {/* 隐藏字段 */}
            <ProFormText
              hidden
              width="md"
              name="levelType"
              label="申请类型"
            />
            <ProFormText
              hidden
              width="md"
              name="levelName"
              label="等级名称"
            />
            <ProFormSelect
              label="申请等级名称"
              rules={[{ required: true }]}
              request={async (params) => {
                const unitRequest = await fetchLevelList();
                return unitRequest.map((item: any) => ({
                  value: item?.id,
                  label: internationalList(item?.levelName || ''),
                }))
              }}

              fieldProps={{
                onChange: async (value) => {
                  let data = await fetchLevelList()
                  let row = data.find((item: any) => item.id === value)
                  form.setFieldsValue({ levelType: row?.levelType || '' });
                  form.setFieldsValue({ levelName: row?.levelName || '' });
                }
              }}
              name='levelId'
              width="md"
              placeholder="选择申请等级名称"
            />
          </Col>
          <Col span={1} />
          {/* <Col span={7}>
            <ProFormText
              disabled={selectRow.wechatId ? true : false}
              width="md"
              name="wechatId"
              label="微信号"
              placeholder="请输入微信号"
            />
          </Col> */}
        </Row>

        <Row>
          <Col span={7}>
            <ProFormSelect
              rules={[{ required: true }]}
              options={convertEnumToOptionType('credentialsType') || []}
              name="credentialsType"
              label='证件类型'
              placeholder='请选择证件类型'
            />
          </Col>
          <Col span={1} />
          <Col span={7}>
            <ProFormText
              disabled={selectRow.credentialsNo ? true : false}
              width="md"
              name="credentialsNo"
              label="证件号码"
              placeholder="请输入证件号码"
              rules={[{ required: true }]}
            />
          </Col>
          <Col span={1} />
          <Col span={7}>
            <ProFormText
              width="md"
              disabled={selectRow.phoneRegion ? true : false}
              name="phoneRegion"
              label="手机区号"
              placeholder="请输入手机区号"
            />
          </Col>
        </Row>
        <Row>
          <Col span={7}>
            <ProFormText
              width="md"
              name="phone"
              disabled={selectRow.phone ? true : false}
              label="手机号"
              rules={[{ required: true }]}
              placeholder="请输入手机号"
            />
          </Col>


          <Col span={1} />
          {/* <Col span={7}>
            <ProFormText
              width="md"
              hidden
              name="sourceName"
              label="推荐人姓名"
              placeholder="请输入推荐人姓名"
            />
            <ProFormText
              width="md"
              hidden
              name="invitorId"
              label="邀请人id"
              placeholder="请输入邀请人id"
            />
            <SelectSearch name="authorizationCode" disabled={entity.id ? true : false} onChange={(value) => {
              let row = inviterData.find((item: any) => item.account === value)
              if (row) {
                form.setFieldsValue({ sourceName: row?.name || '', invitorId: row.id, sourceAuthorizationCode: row.account });
              }
            }} width="sm" defaultParams='' required={false} optionValue="account" label='推荐人姓名' fetchFunc={searchCustomerList} labelValue="name" searchParams='name.contains' />

          </Col>
          <Col span={1} />

          <Col span={7}>
            <ProFormText
              disabled
              width="md"
              name="sourceAuthorizationCode"
              label="推荐授权码"
              placeholder="请输入推荐授权码"
            />
          </Col>
          <Col span={1} /> */}
          <Col span={7}>
            <ProFormSelect label="店铺" rules={[{ required: true }]} fieldProps={{
              onChange: (e) => {
                form.setFieldsValue({
                  brandIds: []
                })

              }
            }} name="storeId" placeholder="店铺" request={fetchStoreList} />
          </Col>
          <Col span={1} />
          {/* <ProFormDependency name={['storeId']}>
            {({ storeId }) => {
              console.log(storeId)
              return storeId && <><Col span={7}>
                <Form.Item name={'brandIds'} className="wid100">
                  <SelectSearch name="brandIds" width="sm" defaultParams="" togetherParams={{ 'storeId.equals': storeId }} mode="multiple" label='授权品牌' fetchFunc={fetchBrandList} labelValue="brandName" searchParams='name.contains' />
                </Form.Item>
              </Col>
              </>
            }}
          </ProFormDependency> */}
          <Col span={24} />
          <Col span={7}>
            <Form.Item label='联系地址' name={['addressApplication', 'district']} rules={[{ required: true }]} >
              <Input.Group compact>
                <Form.Item name={['addressApplication', 'province']} noStyle rules={[{ required: true }]}>
                  <Select style={{ width: 100 }} onChange={handleProvinceChange} placeholder='省'>
                    {provinceSelectData && provinceSelectData.map((province: ProvinceCode) => (
                      <Option key={province.code} value={String(province.code)}>{province.name}</Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name={['addressApplication', 'city']} noStyle rules={[{ required: false }]}>
                  <Select style={{ width: 100 }} onChange={handleCityChange} placeholder='市' >
                    {citySelectData && citySelectData.map((city: ProvinceCode) => (
                      <Option disabled={city.name === '石家庄市'} key={city.code} value={String(city.code)}>{city.name}</Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name={['addressApplication', 'district']} noStyle rules={[{ required: false }]}>
                  <Select style={{ width: 100 }} placeholder='区'
                    onChange={(value, option: any) => form.setFieldsValue({ addressApplication: { districtName: option['children'] } })}>
                    {districtSelectData && districtSelectData.map((district: ProvinceCode) => (
                      <Option key={district.code} value={String(district.code)}>{district.name}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Input.Group>
            </Form.Item>
          </Col>
          <Col span={1} />
          <Col span={8}>
            <ProFormTextArea
              width="md"
              name={["addressApplication", "address"]}
              label="详细地址"
              rules={[{ required: true }]}
              placeholder="请输入详细地址"
            />
          </Col>
        </Row>

        {entity.id &&
          <Row>
            <Col span={10}>
              <Form.Item name="avatar" label="头像" >
                <Image src={entityCopy.avatar} width={100} height={100} fallback="data:image/png;base64,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"></Image>
              </Form.Item>
            </Col>

          </Row>
        }
      </EditPage>
      {/* 选择客户 */}
      <CustomerSelectForm
        multiple={false}
        visible={visible}
        onVisibleChange={(data: any) => {
          if (!data) {
            setVisible(false)
          }
        }}
        onFinish={(keys, data) => {
          let row: any = data[0]
          let relationship: any = row.relationshipList[0]
          setDataFun('edite')
          let obj: any = {
            name: row?.name,
            wechatId: row?.wechatId,
            credentialsType: row?.credentialsType,
            credentialsNo: row?.credentialsNo,
            phoneRegion: row?.phoneRegion,
            phone: row?.phone,
            userId: row?.userId,
            customerId: parseInt(row?.id),
            addressApplication: row?.address,
            brandIds: !!relationship?.authorizedBrands ? (relationship?.authorizedBrands.map((item: any) => { return item + "" })) : [],
            storeId: relationship?.storeId
          }
          setSelectRow(obj)
          form.setFieldsValue(obj)
        }} />
    </>
  )
};

const mapStateToProps = ({ unit }: RootState) => ({
  entity: unit.entity,
  updateSuccess: unit.updateSuccess,
  updating: unit.updating,
  createSuccess: unit.createSuccess
});

const mapDispatchToProps = {
  getEntity,
  createEntity,
  updateEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;


export default connect(mapStateToProps, mapDispatchToProps)(UnitEdit);
